import { Box, Container, Heading, Text, VStack, Link, Icon } from '@chakra-ui/react';
import { ArrowBackIcon } from '@chakra-ui/icons';
import { Link as RouterLink } from 'react-router-dom';

const TermsOfService = () => {
    return (
        <Box h="100vh" overflowY="auto" bg="gray.50" py={10}>
            <Container maxW="container.md" bg="white" p={8} borderRadius="xl" boxShadow="md">
                <VStack spacing={6} align="start">
                    <Link as={RouterLink} to="/login" color="brand.500" fontWeight="bold" display="flex" alignItems="center">
                        <Icon as={ArrowBackIcon} mr={2} />
                        返回登入頁 (Back to Login)
                    </Link>

                    <Heading as="h1" size="xl" color="brand.800">服務條款 (Terms of Service)</Heading>
                    <Text fontSize="sm" color="gray.500">生效日期：2026年1月28日</Text>

                    <Box w="full">
                        <Heading as="h2" size="md" mb={3} mt={6}>1. 接受條款</Heading>
                        <Text color="gray.700" lineHeight="1.8">
                            歡迎使用天籟徐薇補習班平台（以下簡稱「本服務」）。當您下載、安裝或使用本應用程式時，即表示您同意遵守本服務條款。
                        </Text>

                        <Heading as="h2" size="md" mb={3} mt={6}>2. 帳號安全</Heading>
                        <Text color="gray.700" lineHeight="1.8">
                            使用者應妥善保管帳號與密碼。任何透過您的帳號進行的操作，均視為您本人的行為。若發現帳號遭盜用，請立即通知我們。
                        </Text>

                        <Heading as="h2" size="md" mb={3} mt={6}>3. 使用規範</Heading>
                        <Text color="gray.700" lineHeight="1.8">
                            您同意不會利用本服務進行任何非法、騷擾、詐欺或侵害他人權益的行為。補習班保有終止違規帳號使用權的權利。
                        </Text>

                        <Heading as="h2" size="md" mb={3} mt={6}>4. 服務變更</Heading>
                        <Text color="gray.700" lineHeight="1.8">
                            我們持續改善服務內容，可能會在不預先通知的情況下更新、暫停或終止部分功能。
                        </Text>

                        <Heading as="h2" size="md" mb={3} mt={6}>5. 免責聲明</Heading>
                        <Text color="gray.700" lineHeight="1.8">
                            本服務按「現狀」提供，不保證服務絕對無中斷或無錯誤。對於因網路連線問題導致的通知延遲或遺漏，我們不承擔相關責任。
                        </Text>
                    </Box>
                </VStack>
            </Container>
        </Box>
    );
};

export default TermsOfService;
